import { SubscribeForm } from '@/app/entities/subscribe'
import { useCurrentOrg } from '@/app/entities/org/model'
import { useMe } from '@/common/entities/me/model/me'
import { Card } from '@/common/ui/Card'
import { useCurrentSubscriptionPeriod } from '../model/useCurrentSubscriptionPeriod'
import { ActiveSubscriptionDetails } from './ActiveSubscriptionDetails'

type SubscriptionCardProps = {
    onSubscribeSuccess?: () => void
}

export const SubscriptionCard = ({ onSubscribeSuccess }: SubscriptionCardProps) => {
    const { me } = useMe()
    const { data: currentOrg } = useCurrentOrg()
    const { subscription, currentPeriod, hasActiveSubscription, isLoading, refetch } = useCurrentSubscriptionPeriod(
        currentOrg?.id
    )
    const isAdmin = Boolean(me?.is_admin)
    const showSubscribeForm = !hasActiveSubscription || isAdmin

    const handleSubscribeSuccess = () => {
        void refetch()
        onSubscribeSuccess?.()
    }

    return (
        <Card className='relative'>
            <div className='flex flex-col gap-6'>
                <h3 className='text-lg font-medium'>Подписка</h3>

                {hasActiveSubscription && subscription && (
                    <ActiveSubscriptionDetails
                        plan={subscription.plan}
                        daysRemaining={subscription.days_remaining ?? 0}
                        tokensGranted={currentPeriod?.tokens_granted ?? 0}
                        isAutoRenew={subscription.is_auto_renew}
                        expiresAt={subscription.expires_at}
                        isLoading={isLoading}
                    />
                )}

                {showSubscribeForm && (
                    <>
                        {!hasActiveSubscription && (
                            <p className='text-sm text-pixorion-gray-2'>У вас пока нет действующей подписки</p>
                        )}
                        <SubscribeForm onSuccess={handleSubscribeSuccess} />
                    </>
                )}
            </div>
        </Card>
    )
}
